import React from 'react';

import {
  ReferencePageProps,
  ReferencePage,
} from '../ReferencePage/ReferencePage';

const ReferenceDeprecatedIndexPage = ({ aside }: ReferencePageProps) => {
  return (
    <ReferencePage
      eyebrow="Square API"
      title="Deprecated"
      subTitle="View older Connect APIs, endpoints, and webhooks that have been deprecated and replaced with newer versions in the Square API."
      aside={aside}
    />
  );
};

export { ReferenceDeprecatedIndexPage };
